import { Pipe } from '@angular/core';
import { isNumberFinite } from '../utils/utils';
var RadiansPipe = (function () {
    function RadiansPipe() {
    }
    RadiansPipe.prototype.transform = function (input) {
        if (!isNumberFinite(input)) {
            return 'NaN';
        }
        return (input * Math.PI) / 180;
    };
    return RadiansPipe;
}());
export { RadiansPipe };
RadiansPipe.decorators = [
    { type: Pipe, args: [{
                name: 'radians'
            },] },
];
/** @nocollapse */
RadiansPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=radians.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/math/radians.pipe.js
// module id = 265
// module chunks = 103